module.exports = __webpack_public_path__ + "images/marketing/ill-updates.svg";